import { ParsedToken, User } from "firebase/auth";
import React, { createContext, useMemo, useReducer } from "react";
import { Actions } from "./types";
import { reducer } from "./materialReducer";
import { responseType } from "../../../../../../../utils/formTypes";
import { AtsMrfMstForRfqsEdge, rfqPendingItemType } from "../../queries/types";

export type RFQStatesType = {
  mrf: AtsMrfMstForRfqsEdge | null;
  itm: rfqPendingItemType | null;
  selectedSuppliers: responseType[];
};

export const initialState: RFQStatesType = {
  mrf: null,
  itm: null,
  selectedSuppliers: [],
};

const AppContext = createContext<{
  state: RFQStatesType;
  dispatch: React.Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null,
});
interface Props {
  children: React.ReactNode;
}
const AppProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <AppContext.Provider value={{ dispatch, state }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppProvider, AppContext };
